document.addEventListener('DOMContentLoaded', () => {
	const menu    = document.getElementById('mobile-menu');
	const burger  = document.getElementById('burger-btn');
	const closeBtn = document.getElementById('mobile-menu-close');
	const overlay = menu?.querySelector('.mobile-menu__overlay');

	if (!menu || !burger) return;

	// ── Ліниве підвантаження каталогу ─────────────────────
	// Каталог (~360 КБ розмітки) не вбудований у сторінку: забираємо його у фоні після load
	// (лише мережею — браузер закешує), а в DOM вставляємо при першому відкритті меню.
	const lazy = menu.querySelector('.mobile-menu__lazy[data-fragment-src]');
	let fragmentHtml = null;
	let fragmentPromise = null;

	const fetchFragment = () => {
		if (!lazy) return Promise.resolve();
		if (!fragmentPromise) {
			fragmentPromise = fetch(lazy.dataset.fragmentSrc, { credentials: 'same-origin' })
				.then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
				.then((html) => { fragmentHtml = html; })
				.catch(() => { fragmentPromise = null; });
		}
		return fragmentPromise;
	};

	const ensureFragment = () => fetchFragment().then(() => {
		if (lazy && lazy.isConnected && fragmentHtml !== null) {
			lazy.insertAdjacentHTML('beforebegin', fragmentHtml);
			lazy.remove();
		}
	});

	if (lazy) {
		const prefetch = () => {
			// Бургер видно лише на мобільних/планшетах — на десктопі фрагмент не потрібен.
			if (burger.offsetParent === null) return;
			(window.requestIdleCallback || ((cb) => setTimeout(cb, 1500)))(() => fetchFragment(), { timeout: 4000 });
		};
		if (document.readyState === 'complete') prefetch();
		else window.addEventListener('load', prefetch, { once: true });
		burger.addEventListener('pointerdown', fetchFragment, { once: true, passive: true });
	}

	// ── Open / close ──────────────────────────────────────
	const openMenu = () => {
		ensureFragment();
		menu.classList.add('is-open');
		document.body.style.overflow = 'hidden';
		burger.setAttribute('aria-expanded', 'true');
		menu.setAttribute('aria-hidden', 'false');
		menu.inert = false;
	};

	const closeMenu = () => {
		menu.classList.remove('is-open');
		document.body.style.overflow = '';
		burger.setAttribute('aria-expanded', 'false');
		menu.setAttribute('aria-hidden', 'true');
		menu.inert = true; // закрите вікно — поза фокусом і деревом доступності
		// Reset to root level after transition ends
		setTimeout(resetToRoot, 320);
	};

	burger.addEventListener('click', openMenu);
	closeBtn?.addEventListener('click', closeMenu);
	overlay?.addEventListener('click', closeMenu);

	document.addEventListener('keydown', e => {
		if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
	});

	// ── Drill-down ────────────────────────────────────────
	const navWrap = menu.querySelector('.mobile-menu__nav-wrap');
	if (!navWrap) return;

	const getActivePanel = () => navWrap.querySelector('.mobile-menu__nav-panel.is-active');

	// Стек переходів: панелі можуть бути доступні з кількох точок входу
	// (наприклад mob-cat-панель — і з «Каталогу», і з пункту меню), тож
	// «назад» повертає туди, звідки прийшли, а не до статичного data-parent-panel.
	const history = [];

	const goDeeper = (parentPanel, childPanel, parentLabel) => {
		// Update back label
		const backLabel = childPanel.querySelector('.mobile-menu__back-label');
		if (backLabel) backLabel.textContent = parentLabel;

		history.push(parentPanel.dataset.panelId);

		parentPanel.classList.add('is-leaving');
		parentPanel.classList.remove('is-active');

		// Force reflow before adding is-active so transition fires
		childPanel.getBoundingClientRect();
		childPanel.classList.add('is-active');
		childPanel.scrollTop = 0;
	};

	const goBack = (childPanel) => {
		const prevPanelId = history.pop() || childPanel.dataset.parentPanel;
		const prevPanel = navWrap.querySelector(`[data-panel-id="${prevPanelId}"]`);
		if (!prevPanel) return;

		childPanel.classList.remove('is-active');

		prevPanel.classList.remove('is-leaving');
		prevPanel.classList.add('is-active');

		// Scroll to top of parent panel
		prevPanel.scrollTop = 0;
	};

	// Clicks on items that open submenus
	navWrap.addEventListener('click', e => {
		// Drill deeper
		const drillBtn = e.target.closest('[data-opens-panel]');
		if (drillBtn) {
			const targetPanelId = drillBtn.dataset.opensPanel;
			const label         = drillBtn.dataset.label || '';
			const drill = () => {
				const targetPanel = navWrap.querySelector(`[data-panel-id="${targetPanelId}"]`);
				const activePanel = getActivePanel();
				if (targetPanel && activePanel) {
					goDeeper(activePanel, targetPanel, label);
				}
				return !!targetPanel;
			};
			// Панелі каталогу могли ще не підвантажитись — дочекатись фрагмента й повторити.
			if (!drill() && lazy) ensureFragment().then(drill);
			return;
		}

		// Go back
		const backBtn = e.target.closest('.mobile-menu__back');
		if (backBtn) {
			const childPanel = backBtn.closest('.mobile-menu__nav-panel');
			if (childPanel) goBack(childPanel);
		}
	});

	const resetToRoot = () => {
		history.length = 0;
		const panels = navWrap.querySelectorAll('.mobile-menu__nav-panel');
		panels.forEach((p, i) => {
			p.classList.remove('is-active', 'is-leaving');
			if (i === 0) p.classList.add('is-active');
		});
	};
});
